import {useTheme} from "@mui/material/styles";
import useMediaQuery from "@mui/material/useMediaQuery";
import React from "react";
import './SidebarNavButton.css';

const sidebarLabelStyle = {
    fontSize: '0.875rem',     // Tailwind `text-sm` (14px at 16px root)
    lineHeight: '1.25rem',    // 20px line-height (Tailwind default for text-sm)
    fontWeight: 500,          // `font-medium`
    whiteSpace: 'nowrap',     // `whitespace-nowrap`
    maxWidth: '168px',        // `max-w-[168px]`
    overflow: 'hidden',       // part of `truncate`
    textOverflow: 'ellipsis', // part of `truncate`
};

const textStyle = {
    fontSize: "14px",
    fontWeight: "medium",
    lineHeight: "27px",
    letterSpacing: '-0.5px',
    color: "var(--app-text-primary)"
}

const SidebarNavButton = ({ icon, label, selected = false, onClick }) => {
    const theme = useTheme();
    const isXl = useMediaQuery(theme.breakpoints.up('xl'));
    const isLg = useMediaQuery(theme.breakpoints.up('lg'));

    const width = isXl ? '250px' : isLg ? '230px' : '220px';

    return (
        <button
            className={`sidebar-nav-button ${selected ? 'selected' : ''}`}
            onClick={onClick}
            style={{ width }}
        >
            <span className="icon">{icon}</span>
            <span style={textStyle}>{label}</span>
        </button>
    );
};

export const SidebarSubdirButton = ({ icon, label, selected = false, onClick }) => {
    const theme = useTheme();
    const isXl = useMediaQuery(theme.breakpoints.up('xl'));
    const isLg = useMediaQuery(theme.breakpoints.up('lg'));

    const width = isXl ? '250px' : isLg ? '230px' : '220px';

    return (
        <button
            className={`sidebar-nav-button ${selected ? 'selected' : ''}`}
            onClick={() => {}}
            style={{ width }}
        >
            <span className="icon" style={{marginLeft: "10px"}}>{icon}</span>
            <span style={sidebarLabelStyle}>{label}</span>
        </button>
    );
}

export default SidebarNavButton;
